<template>
  <div class="route-loading" aria-busy="true" aria-live="polite">
    <div class="route-loading__skeleton">
      <div class="route-loading__bar route-loading__bar--title" />
      <div class="route-loading__bar route-loading__bar--short" />
      <div class="route-loading__bar route-loading__bar--medium" />
      <div class="route-loading__bar route-loading__bar--full" />
    </div>
    <span class="route-loading__text">页面加载中…</span>
  </div>
</template>

<script>
export default {
  name: 'RouteLoading'
}
</script>

<style scoped>
.route-loading {
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #909399;
  font-size: 14px;
  background: #f5f7fa;
  border-radius: 8px;
  padding: 24px 20px;
  box-sizing: border-box;
}
.route-loading__skeleton {
  width: min(100%, 420px);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.route-loading__bar {
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #ebeef5 0%, #f5f7fa 50%, #ebeef5 100%);
  background-size: 200% 100%;
  animation: route-loading-shimmer 1.2s ease-in-out infinite;
}
.route-loading__bar--title {
  width: 38%;
  height: 16px;
}
.route-loading__bar--short {
  width: 55%;
}
.route-loading__bar--medium {
  width: 72%;
}
.route-loading__bar--full {
  width: 100%;
  height: 80px;
  border-radius: 8px;
}
.route-loading__text {
  user-select: none;
}
@keyframes route-loading-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
@media (prefers-reduced-motion: reduce) {
  .route-loading__bar {
    animation: none;
    background: #ebeef5;
  }
}
</style>
